var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',_vm._g(_vm._b({ref:"switch",staticClass:"x-switch",attrs:{"color":_vm.color,"input-value":_vm.value,"hide-details":""}},'v-switch',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }